const initialState = {
  retrieveTopicsBegin: false,
  retrieveTopicsFailure: false,
  allTopics: [],

  retrieveTopicPreviewBegin: false,
  retrieveTopicPreviewSuccess: false,
  retrieveTopicPreviewFailure: false,
  topicPreviewPosts: [],
  topicPreviewTotalPostsCount: null,
  topicPreviewTotalCommentsCount: null,
  topicPreviewEstimatedProcessingTimeInHours: null,

  createTopicsBegin: false,
  createTopicsSuccess: false,
  createTopicsFailure: false,
  createdTopicId: null,

  retrieveCategoriesBegin: true,
  retrieveCategoriesFailure: false,
  retrieveCategoriesSuccess: false,
  allCategories: [],

  updateTopicsSuccess: false,
  updateTopicsFailure: false,
  updateTopicsBegin: false,
  updateTopicsTopicProcessedState: null,

  deleteTopicBegin: false,
  deleteTopicFailure: false,
  deleteTopicSuccess: false,

  uploadFileBegin:   false,
  uploadFileFailure: false,
  uploadFileSuccess: false,

  retrieveAllUploadedFilesForTopicBegin:   false,
  retrieveAllUploadedFilesForTopicFailure: false,
  retrieveAllUploadedFilesForTopicSuccess: false,
  allUploadedFilesForTopic: {}
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/topics/redux/initialState.js